import { Box, Card, IconButton, Typography } from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import DownloadReportsHealth from '../DownloadReportsHealth';
import { Stack, styled } from '@mui/system';

const CardWrapper = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.secondary.dark,
    color: '#fff',
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background:
            theme.palette.mode === 'dark'
                ? `linear-gradient(210.04deg, ${theme.palette.secondary.dark} -50.94%, rgba(144, 202, 249, 0) 95.49%)`
                : theme.palette.secondary[800],
        borderRadius: '50%',
        top: -85,
        right: -95,
        [theme.breakpoints.down('sm')]: {
            top: -105,
            right: -140
        }
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: 210,
        height: 210,
        background:
            theme.palette.mode === 'dark'
                ? `linear-gradient(140.9deg, ${theme.palette.secondary.dark} -14.02%, rgba(144, 202, 249, 0) 85.50%)`
                : theme.palette.secondary[800],
        borderRadius: '50%',
        top: -125,
        right: -15,
        opacity: 0.5,
        [theme.breakpoints.down('sm')]: {
            top: -155,
            right: -70
        }
    }
}));

export const HeaderWrapperView = ({ dataToDownload, title }: { dataToDownload?: any[]; title: string }) => {
    return (
        <CardWrapper sx={{ mb: 2 }}>
            <Box sx={{ py: 3, px: 1 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center">
                        <IconButton component={Link} to="/loolu/admin/health-content/overall-score">
                            {/* <Link to="/loolu/admin/health-content/overall-score"> */}
                            <ArrowBackIcon fontSize="inherit" />
                            {/* </Link> */}
                        </IconButton>
                        <Typography variant="h2">{title}</Typography>
                    </Stack>
                    {dataToDownload && <DownloadReportsHealth dataToDownload={dataToDownload} />}
                </Stack>
            </Box>
        </CardWrapper>
    );
};
